import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import { isAuthConfigured } from '../../lib/supabase';
import { Spinner } from '../common/Spinner';

/**
 * Lightweight auth guard that only checks for a valid session.
 * Unlike ProtectedRoute, it does NOT run the onboarding check — it is used
 * specifically for the /onboarding page itself, which is already past the
 * "do you have a session?" gate but not yet past the "do you have an org?" one.
 *
 * When auth is not configured (no Supabase env vars) the guard is a no-op.
 */
export function SessionGuard() {
  const { session, isLoading } = useAuthStore();

  // Bootstrap/dev/CI mode — render without auth
  if (!isAuthConfigured) {
    return <Outlet />;
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-surface-0">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
